import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const sliderContent = [
  {
    title: "SELL YOUR CAR",
    subtitle: "Upload your vehicle in minutes and reach thousands of buyers.",
    color: "#3b82f6",
    action: "COMING BACK (29-03-26) ",
  },
  {
    title: "BUY WITH CONFIDENCE",
    subtitle: "Explore verified listings and find the perfect car for your needs.",
    color: "#10b981",
    action: "COMING BACK (29-03-26) ",
  },
  {
    title: "POST. CONNECT. GET OFFERS.",
    subtitle: "List your car and receive instant interest from real buyers.",
    color: "#f59e0b",
    action: "COMING BACK (29-03-26) ",
  },
];

const HeroSection = ({ customImages = [] }) => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isAuto, setIsAuto] = useState(true);

  // Your Ghana-based phone number
  const phoneNumber = '+233242201875'; 
  const formattedPhoneNumber = '+233 242 201 875';

  // Use customImages if provided
  const imagesToUse = customImages.length > 0 ? customImages : [
    // Fallback if no images provided (you can remove these)
    '/fallback1.jpg',
    '/fallback2.jpg',
    '/fallback3.jpg',
  ];

  useEffect(() => {
    if (!isAuto) return;
    const timer = setInterval(() => changeSlide(1), 7000);
    return () => clearInterval(timer);
  }, [current, isAuto]);

  const changeSlide = (step) => {
    setDirection(step);
    setCurrent((prev) => (prev + step + imagesToUse.length) % imagesToUse.length);
  };

  const socialLinks = {
    whatsapp: `https://wa.me/${phoneNumber.replace(/\s/g, '')}?text=Hi!%20I'm%20interested%20in%20buying%20or%20selling%20a%20car.%20Can%20you%20help%20me?`,
    instagram: 'https://instagram.com',
    twitter: 'https://twitter.com',
  };

  //commit text

  const smoothEase = [0.19, 1, 0.22, 1];
  const gentleEase = [0.16, 1, 0.3, 1];

  return (
    <section className="relative w-screen h-screen bg-black overflow-hidden font-sans select-none">
      {/* Cinematic Particles Layer */}
      <div className="absolute inset-0 z-10 pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute bg-white rounded-full opacity-20 blur-[2px]"
            style={{
              width: Math.random() * 4 + 2,
              height: Math.random() * 4 + 2,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -100],
              x: [0, Math.random() * 50 - 25],
              opacity: [0, 0.4, 0],
            }}
            transition={{
              duration: Math.random() * 5 + 5,
              repeat: Infinity,
              ease: "linear",
              delay: Math.random() * 5,
            }}
          />
        ))}
      </div>

      {/* Background Cinematic Engine */}
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          key={current}
          custom={direction}
          initial={{ opacity: 0, scale: 1.2, filter: 'blur(10px)' }}
          animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
          exit={{ opacity: 0, scale: 0.9, filter: 'blur(20px)' }}
          transition={{ duration: 1.5, ease: smoothEase }}
          className="absolute inset-0"
        >
          <img 
            src={imagesToUse[current]} 
            className="w-full h-full object-cover origin-center" 
            alt={`Car ${current + 1}`}
          />
          <motion.div 
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"
            animate={{ x: ['-100%', '200%'] }}
            transition={{ duration: 3, repeat: Infinity, ease: "linear", repeatDelay: 4 }}
          />
          <div className="absolute inset-0 bg-black/40 backdrop-contrast-125" />
        </motion.div>
      </AnimatePresence>

      {/* Content HUD */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-6">
        <motion.div
          key={current}
          initial="hidden"
          animate="visible"
          className="max-w-6xl w-full"
        >
          {/* Title - Simple fade in with gentle ease */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: gentleEase }}
            className="text-[8vw] leading-none font-black text-white italic tracking-tighter mb-4"
          >
            {sliderContent[current].title}
          </motion.h1>

          {/* Subtitle - Simple fade in with delay */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="text-white text-xl md:text-2xl font-light tracking-wide uppercase mb-12 max-w-3xl mx-auto"
          >
            {sliderContent[current].subtitle}
          </motion.p>

          {/* Main CTA Button */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, ease: smoothEase }}
          >
            <button className="group relative px-12 py-5 bg-white rounded-md overflow-hidden transition-all duration-500 hover:px-16 active:scale-95 ease-[cubic-bezier(0.19,1,0.22,1)]">
              <span className="relative z-10 text-black font-bold tracking-widest text-sm transition-all duration-500 ease-[cubic-bezier(0.19,1,0.22,1)]">
                {sliderContent[current].action}
              </span>
              <motion.div 
                className="absolute inset-0 bg-gray-200" 
                initial={{ x: '-100%' }}
                whileHover={{ x: 0 }}
                transition={{ duration: 0.4, ease: smoothEase }}
              />
            </button>
          </motion.div>
        </motion.div>
      </div>

      {/* Phone Call Section */}
   <motion.a 
  href={`tel:${phoneNumber}`}
  className="absolute top-12 right-4 z-30 md:top-1/2 md:right-0 md:-translate-y-1/2 md:transform md:-rotate-90 md:origin-top-right"
  initial={{ y: '-50%', x: 50, opacity: 0 }}
  animate={{ y: '-50%', x: 0, opacity: 1 }}
  transition={{ delay: 1.5, type: 'spring', stiffness: 100 }}
>
  <div className="flex items-center gap-3 md:gap-6 bg-white/10 backdrop-blur-lg p-3 md:p-5 shadow-2xl cursor-pointer border border-white/20 rounded-lg md:rounded-xl transition-all duration-300 hover:bg-white/15 hover:border-cyan-400 max-w-[200px] md:max-w-sm w-full">
    <svg className="w-5 h-5 md:w-7 md:h-7 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
    <div className="flex flex-col items-start">
      <span className="text-cyan-300 text-[10px] md:text-xs font-bold tracking-widest uppercase whitespace-nowrap mb-0.5">
        BUY OR SELL YOUR CAR
      </span>
      <span className="text-white text-sm md:text-xl font-extrabold tracking-wider">
        {formattedPhoneNumber}
      </span>
    </div>
  </div>
</motion.a>

      {/* Social Media HUD - Simplified (No Expand on Hover) */}
      <motion.div 
        className="absolute top-8 right-8 z-30 hidden lg:block"
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.8, ease: smoothEase }}
      >
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col gap-4">
            {/* Instagram - No expansion */}
            {/* <a 
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center p-3 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-all duration-300 shadow-[0_4px_30px_rgba(0,0,0,0.1)]"
            >
              <svg 
                className="w-5 h-5 text-white/80 hover:text-white transition-colors duration-300"
                fill="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a> */}

            {/* WhatsApp - No expansion */}
            <a 
              href={socialLinks.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center p-3 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-all duration-300 shadow-[0_4px_30px_rgba(0,0,0,0.1)]"
            >
              <svg 
                className="w-5 h-5 text-white/80 hover:text-white transition-colors duration-300"
                fill="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411"/>
              </svg>
            </a>

            {/* Twitter - No expansion */}
            {/* <a 
              href={socialLinks.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center p-3 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-all duration-300 shadow-[0_4px_30px_rgba(0,0,0,0.1)]"
            >
              <svg 
                className="w-5 h-5 text-white/80 hover:text-white transition-colors duration-300"
                fill="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.213c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
              </svg>
            </a> */}
          </div>

          <div className="w-px h-20 bg-gradient-to-b from-transparent via-white/10 to-transparent" />
        </div>
      </motion.div>

      {/* Glass Navigation HUD */}
      <motion.div 
        className="absolute bottom-12 left-1/2 -translate-x-1/2 z-30 flex items-center gap-8 px-8 py-4 bg-white/5 backdrop-blur-2xl rounded-full border border-white/10 shadow-[0_0_50px_rgba(0,0,0,0.5)]"
        whileHover={{ 
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
          borderColor: 'rgba(255, 255, 255, 0.15)'
        }}
        transition={{ duration: 0.5, ease: smoothEase }}
      >
        <NavBtn onClick={() => { changeSlide(-1); setIsAuto(false); }}>
            <span className="text-white/60 transition-all duration-300 hover:text-white">
              PREV
            </span>
        </NavBtn>

        <div className="flex gap-3">
          {imagesToUse.map((_, i) => (
            <motion.div
              key={i}
              className="h-[2px] rounded-full bg-white"
              initial={false}
              animate={{ 
                width: current === i ? 40 : 10,
                opacity: current === i ? 1 : 0.3 
              }}
              transition={{ duration: 0.6, ease: smoothEase }}
            />
          ))}
        </div>

        <NavBtn onClick={() => { changeSlide(1); setIsAuto(false); }}>
            <span className="text-white transition-all duration-300 hover:text-white">
              NEXT
            </span>
        </NavBtn>
      </motion.div>

      {/* Mobile WhatsApp Button - Simplified */}
      <motion.div 
        className="absolute top-8 left-8 z-30 lg:hidden"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.8, type: 'spring' }}
      >
        <a 
          href={socialLinks.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center p-3 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-all duration-300 shadow-[0_4px_30px_rgba(0,0,0,0.1)]"
        >
          <svg 
            className="w-5 h-5 text-white/80 hover:text-white"
            fill="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411"/>
          </svg>
        </a>
      </motion.div>
    </section>
  );
};

const NavBtn = ({ children, onClick }) => (
  <button 
    onClick={onClick}
    className="group flex items-center gap-2 tracking-widest text-[10px] font-bold transition-all duration-300 hover:scale-110 active:scale-90"
  >
    {children}
  </button>
);

export default HeroSection;